import { addToChainAfter } from "@insite/client-framework/HandlerCreator";
import { chain, RequestDataFromApi } from "@insite/client-framework/Store/Context/Handlers/LoadSettings";

export type HandlerType = Parameters<typeof RequestDataFromApi>[0];

addToChainAfter(chain, RequestDataFromApi, ParseInvoiceCreditCardData);

function ParseInvoiceCreditCardData(props: HandlerType) {
    const settingsModel = props.apiResult;

    if (props.apiResult.settingsCollection.productSettings) {
        const productSettings = props.apiResult.settingsCollection.productSettings;
        if (settingsModel.properties["documentIconsRootPath"]) {
            productSettings.documentIconsRootPath = settingsModel.properties["documentIconsRootPath"];
        }
    }
}
